import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import uiReducer from "./uiSlice";
import vesselReducer from './vesselSlice';
import vesselOverviewSlice from './vesselOverviewSlice';
import aeReducer from './aeSlice';
import dateRangeReducer from "./dateRangeSlice";
import mainEngineReducer from './mainEngineSlice';
import VoyageFilter from './voyageFilterSlice';
import bdnIdSlice from './bdnIdSlice';
import themeReducer from './themeSlice';
import benchmarkYearReducer from "./benchmarkYearSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    vessel: vesselReducer,
    ae: aeReducer,
    dateRange: dateRangeReducer,
    vesselOverview: vesselOverviewSlice,
    mainEngine: mainEngineReducer,
    voyageFilter: VoyageFilter,
    bdnId: bdnIdSlice,
    theme: themeReducer,
    benchmarkYear: benchmarkYearReducer,
  },
});

export default store;
